import React from 'react'
import Link from 'gatsby-link'

import logo from '../assets/images/logo.svg';

const Footer = (props) => (
    <footer id="footer">
        <section>
            <h2>Contact</h2>
            <dl className="alt">
                <dt>Adresa</dt>
                <dd>Strada Constantin Noica nr. 140 <br/>Bucuresti, Sector 6, 060057, Romania</dd>
                <dt>Telefon</dt>
                <dd> (004) 0722.367.456</dd>
                <dt>Email</dt>
                <dd> <a href="#">raresuniv@yahoo.com</a></dd>
            </dl>
            <ul className="icons">
                <li><a href="http://www.unefsb.ro" className="icon fa-globe  alt"><span className="label">Website</span></a></li>
            </ul>
        </section>
        <p className="copyright">&copy; UNEFS Erasmus+ Online SignUp </p>
    </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js